import React from 'react'

import {
  CardCollectionShareWrapperData,
  GenerateAuthorizationTokenForCollection,
  GenerateAuthorizationTokenForCollectionVariables,
  Visibility,
} from 'globalTypes'

import ShareContext from 'Root/Contexts/Share'
import apolloClient from 'lib/apollo-client'

import MUTATION from './generate-authorization-token-for-collection.graphql'

interface Props {
  collection: CardCollectionShareWrapperData
  children: React.ReactNode
  refetch?: Function
}

const ShareWrapper = ({ children, collection, refetch }: Props) => {
  const link = `/cc/${collection.slug}`

  let callback
  if (collection.visibility === Visibility.private && collection.canManage) {
    callback = async () => {
      const { data } = await apolloClient.mutate<
        GenerateAuthorizationTokenForCollection,
        GenerateAuthorizationTokenForCollectionVariables
      >({
        mutation: MUTATION,
        variables: {
          id: collection.id,
        },
      })

      return `${link}?token=${data.token}`
    }
  }

  const value = {
    callback,
    canManage: collection.canManage,
    text: collection.description || undefined,
    title: collection.title || undefined,
    type: collection.__typename,
    refetch: refetch,
    visibility: collection.visibility || undefined,
    url: link,
  }

  return <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
}

export default ShareWrapper
